import Vue from "vue";
import Router from "vue-router";

const Login = () => import("@/views/login/login");
const Home = () => import("@/components/home.vue");
const HomeIndex = () => import("@/views/homeIndex.vue");
const Account = () => import("@/views/user/account.vue");
const Role = () => import("@/views/user/role.vue");
const DataDictionary = () => import("@/views/user/dataDictionary.vue");
const EditPassword = () => import("@/views/editPassword.vue");
const EquipmentVendors = () => import("@/views/operate/equipmentVendors");
const DtuManage = () => import("@/views/collection/dtuManage");
const DtuManageRun = () => import("@/views/collection/dtuManageRun");
const DtuManageCost = () => import("@/views/collection/dtuManageCost");
const DtuType = () => import("@/views/collection/dtuType");
const DtuTerm = () => import("@/views/collection/dtuTerm");
const DtuRenew = () => import("@/views/collection/dtuRenew");
const DeviceProtocol = () => import("@/views/collection/deviceProtocol");
const DeviceDataItem = () => import("@/views/collection/deviceDataItem");
const FaultCode = () => import("@/views/collection/faultCode");

const AccountEdit = () => import("@/views/user/accountEdit.vue");
const RoleEdit = () => import("@/views/user/roleEdit.vue");
const DataDictionaryEdit = () => import("@/views/user/dataDictionaryEdit.vue");
const Modular = () => import("@/views/user/modular.vue");
const ModularEdit = () => import("@/views/user/modularEdit.vue");
const ModularApp = () => import("@/views/user/modularApp.vue");

const VendorEdit = () => import("@/views/operate/vendorEdit.vue");
const PlatformAuthority = () => import("@/views/operate/platformAuthority.vue");
const EquipmentType = () => import("@/views/operate/equipmentType.vue");
const VendorAccount = () => import("@/views/operate/vendorAccount.vue");
const VendorAccountEdit = () => import("@/views/operate/vendorAccountEdit.vue");
const VendorModelManagement = () =>
  import("@/views/operate/vendorModelManagement.vue");
const VendorModelEdit = () => import("@/views/operate/vendorModelEdit.vue");
const VendorEquipmentType = () =>
  import("@/views/operate/vendorEquipmentType.vue");
const VendorEquipmentTypeEdit = () =>
  import("@/views/operate/vendorEquipmentTypeEdit.vue");
const VersionApp = () => import("@/views/operate/versionApp.vue");
const VersionAppEdit = () => import("@/views/operate/versionAppEdit.vue");
const SetNameplate = () => import("@/views/operate/setNameplate.vue");
const SetNameplateEdit = () => import("@/views/operate/setNameplateEdit.vue");
const SetPlcControl = () => import("@/views/operate/setPlcControl.vue");
const SetPlcControlEdit = () => import("@/views/operate/setPlcControlEdit.vue");
const ParamPattern = () => import("@/views/operate/paramPattern.vue");
const ParamPatternEdit = () => import("@/views/operate/paramPatternEdit.vue");

const DtuTermEdit = () => import("@/views/collection/dtuTermEdit.vue");
const DtuTypeEdit = () => import("@/views/collection/dtuTypeEdit.vue");
const FaultEdit = () => import("@/views/collection/faultEdit.vue");
const FaultCodeImport = () => import("@/views/collection/faultCodeImport.vue");
const DeviceProtocolEdit = () =>
  import("@/views/collection/deviceProtocolEdit.vue");
const DeviceProtocolEditMQTT = () =>
  import("@/views/collection/deviceProtocolEditMQTT.vue");
const DeviceProtocolLook = () =>
  import("@/views/collection/deviceProtocolLook.vue");
const DeviceProtocolLookMQTT = () =>
  import("@/views/collection/deviceProtocolLookMQTT.vue");
const DeviceProtocolLookList = () =>
  import("@/views/collection/deviceProtocolLookList.vue");
const DeviceProtocolMsg = () =>
  import("@/views/collection/deviceProtocolMsg.vue");
const DeviceProtocolControl = () =>
  import("@/views/collection/deviceProtocolControl.vue");
const DeviceProtocolControlMQTT = () =>
  import("@/views/collection/deviceProtocolControlMQTT.vue");
const DeviceDataItemEdit = () =>
  import("@/views/collection/deviceDataItemEdit.vue");
const DtuManageEdit = () => import("@/views/collection/dtuManageEdit.vue");
const DtuManageMonitor = () =>
  import("@/views/collection/dtuManageMonitor.vue");
const DtuManageMonitorRun = () =>
  import("@/views/collection/dtuManageMonitorRun.vue");
const DtuManageImport = () => import("@/views/collection/dtuManageImport.vue");
const DtuManageHistoryImport = () =>
  import("@/views/collection/dtuManageHistoryImport.vue");
const DeviceInstructions = () =>
  import("@/views/collection/deviceInstructions.vue");
const DeviceInstructionsEdit = () =>
  import("@/views/collection/deviceInstructionsEdit.vue");
const PlcList = () => import("@/views/collection/plcList.vue");
const PlcEdit = () => import("@/views/collection/plcEdit.vue");
const DataGroup = () => import("@/views/collection/dataGroup.vue");
const DataGroupEdit = () => import("@/views/collection/dataGroupEdit.vue");
const DataGroupImport = () => import("@/views/collection/dataGroupImport.vue");
const DataGroupList = () => import("@/views/collection/dataGroupList.vue");
const DataControl = () => import("@/views/collection/dataControl.vue");
const DataControlEdit = () => import("@/views/collection/dataControlEdit.vue");
const DataMould = () => import("@/views/collection/dataMould.vue");
const DataMouldEdit = () => import("@/views/collection/dataMouldEdit.vue");
const DataImport = () => import("@/views/collection/dataImport.vue");
const DataImportEdit = () => import("@/views/collection/dataImportEdit.vue");
const DataItemImport = () => import("@/views/collection/dataItemImport.vue");
const DataItemImportMQTT = () =>
  import("@/views/collection/dataItemImportMQTT.vue");
const DataControlImport = () =>
  import("@/views/collection/dataControlImport.vue");
const DataControlImportMQTT = () =>
  import("@/views/collection/dataControlImportMQTT.vue");
const LoraDtuManage = () => import("@/views/collection/loraDtuManage.vue");
const LoraDtuManageEdit = () =>
  import("@/views/collection/loraDtuManageEdit.vue");
const LoraDtuManageImport = () =>
  import("@/views/collection/loraDtuManageImport.vue");
const SetDtu = () => import("@/views/collection/setDtu.vue");
const SetDtuEdit = () => import("@/views/collection/setDtuEdit.vue");

const DtuManageCostEdit = () =>
  import("@/views/collection/dtuManageCostEdit.vue");
const DtuManageCostList = () =>
  import("@/views/collection/dtuManageCostList.vue");
const SystemField = () => import("@/views/heating/systemField.vue");
const SystemParams = () => import("@/views/heating/systemParams.vue");

const MiddleFile = () => import("@/components/middleFile.vue");

const VendorEdit1 = () => import("@/views/operate/vendorEdit-copy.vue");
Vue.use(Router);
//打包上线是mode模式要是hash
export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      redirect: "/Login"
    },
    {
      path: "/Login",
      name: "登录",
      component: Login
    },
    {
      path: "/home",
      component: Home,
      children: [
        {
          path: "/",
          name: "首页",
          component: HomeIndex
        },
        {
          path: "account",
          name: "用户",
          component: Account
        },
        {
          path: "editPassword",
          name: "修改密码",
          component: EditPassword
        },
        {
          path: "equipmentVendors",
          name: "设备厂商",
          component: EquipmentVendors
        },
        {
          path: "dtuManage",
          name: "DTU管理",
          component: DtuManage
        },
        {
          path: "dtuManageRun",
          name: "DTU实测管理",
          component: DtuManageRun
        },
        {
          path: "dtuType",
          name: "DTU类型",
          component: DtuType
        },
        {
          path: "dtuTerm",
          name: "DTU质保期",
          component: DtuTerm
        },
        {
          path: "deviceProtocol",
          name: "设备协议",
          component: DeviceProtocol
        },
        {
          path: "deviceDataItem",
          name: "设备数据项",
          component: DeviceDataItem
        },
        {
          path: "faultCode",
          name: "故障码",
          component: FaultCode
        },
        {
          path: "role",
          name: "角色",
          component: Role
        },
        {
          path: "dataDictionary",
          name: "数据字典",
          component: DataDictionary
        },
        {
          path: "accountEdit",
          name: "用户信息",
          component: AccountEdit
        },
        {
          path: "roleEdit",
          name: "角色信息",
          component: RoleEdit
        },
        {
          path: "dataDictionaryEdit",
          name: "数据字典信息",
          component: DataDictionaryEdit
        },
        {
          path: "modular",
          name: "功能模块",
          component: Modular
        },
        {
          path: "modularEdit",
          name: "功能模块信息",
          component: ModularEdit
        },
        {
          path: "modularApp",
          name: "app功能模块",
          component: ModularApp
        },
        {
          path: "vendorEdit",
          name: "设备厂商信息",
          component: VendorEdit
        },
        {
          path: "platformAuthority",
          name: "平台权限信息",
          component: PlatformAuthority
        },
        {
          path: "equipmentType",
          name: "设备型号信息",
          component: EquipmentType
        },
        {
          path: "dtuTypeEdit",
          name: "DTU类型信息",
          component: DtuTypeEdit
        },
        {
          path: "dtuTermEdit",
          name: "DTU延保",
          component: DtuTermEdit
        },
        {
          path: "dtuRenew",
          name: "DTU延保记录",
          component: DtuRenew
        },
        {
          path: "faultEdit",
          name: "故障码信息",
          component: FaultEdit
        },
        {
          path: "faultCodeImport",
          name: "故障码导入信息",
          component: FaultCodeImport
        },
        {
          path: "deviceProtocolEdit",
          name: "设备协议信息",
          component: DeviceProtocolEdit
        },
        {
          path: "deviceProtocolEditMQTT",
          name: "新增MQTT协议信息",
          component: DeviceProtocolEditMQTT
        },
        {
          path: "deviceDataItemEdit",
          name: "设备数据项信息",
          component: DeviceDataItemEdit
        },
        {
          path: "dtuManageEdit",
          name: "DTU管理信息",
          component: DtuManageEdit
        },
        {
          path: "dtuManageMonitor",
          name: "DTU管理监测信息",
          component: DtuManageMonitor
        },
        {
          path: "dtuManageMonitorRun",
          name: "DTU管理监测运行信息",
          component: DtuManageMonitorRun
        },
        {
          path: "dtuManageImport",
          name: "DTU导入信息",
          component: DtuManageImport
        },
        {
          path: "dtuManageHistoryImport",
          name: "DTU导入历史",
          component: DtuManageHistoryImport
        },
        {
          path: "dtuManageCost",
          name: "DTU续费管理",
          component: DtuManageCost
        },
        {
          path: "dtuManageCostEdit",
          name: "DTU续费管理信息",
          component: DtuManageCostEdit
        },
        {
          path: "dtuManageCostList",
          name: "DTU续费管理续费列表",
          component: DtuManageCostList
        },

        {
          path: "deviceInstructions",
          name: "设备指令",
          component: DeviceInstructions
        },
        {
          path: "deviceInstructionsEdit",
          name: "设备指令信息",
          component: DeviceInstructionsEdit
        },
        {
          path: "vendorAccount",
          name: "厂商账号",
          component: VendorAccount
        },
        {
          path: "vendorModelManagement",
          name: "厂商产品型号管理",
          component: VendorModelManagement
        },
        {
          path: "vendorModelEdit",
          name: "厂商产品型号信息",
          component: VendorModelEdit
        },
        {
          path: "vendorEquipmentType",
          name: "设备类型",
          component: VendorEquipmentType
        },
        {
          path: "vendorEquipmentTypeEdit",
          name: "设备类型信息",
          component: VendorEquipmentTypeEdit
        },
        {
          path: "versionApp",
          name: "版本管理",
          component: VersionApp
        },
        {
          path: "versionAppEdit",
          name: "版本管理信息",
          component: VersionAppEdit
        },
        {
          path: "vendorAccountEdit",
          name: "厂商账号信息",
          component: VendorAccountEdit
        },
        {
          path: "plcList",
          name: "PLC机组",
          component: PlcList
        },
        {
          path: "plcEdit",
          name: "PLC机组信息",
          component: PlcEdit
        },
        {
          path: "dataGroup",
          name: "数据项分组",
          component: DataGroup
        },
        {
          path: "dataGroupEdit",
          name: "数据项分组信息",
          component: DataGroupEdit
        },
        {
          path: "dataGroupList",
          name: "数据项分组详细",
          component: DataGroupList
        },
        {
          path: "deviceProtocolLook",
          name: "查询指令详细",
          component: DeviceProtocolLook
        },
        {
          path: "deviceProtocolLookMQTT",
          name: "MQTT协议详细",
          component: DeviceProtocolLookMQTT
        },
        {
          path: "deviceProtocolControl",
          name: "协议控制指令",
          component: DeviceProtocolControl
        },
        {
          path: "deviceProtocolControlMQTT",
          name: "MQTT协议控制指令",
          component: DeviceProtocolControlMQTT
        },
        {
          path: "dataControl",
          name: "控制项标准项",
          component: DataControl
        },
        {
          path: "dataControlEdit",
          name: "控制项标准项信息",
          component: DataControlEdit
        },
        {
          path: "dataMould",
          name: "数据项模板",
          component: DataMould
        },
        {
          path: "dataMouldEdit",
          name: "数据项模板信息",
          component: DataMouldEdit
        },
        {
          path: "dataGroupImport",
          name: "数据项分组导入",
          component: DataGroupImport
        },
        {
          path: "deviceProtocolMsg",
          name: "设备协议查看",
          component: DeviceProtocolMsg
        },
        {
          path: "dataImport",
          name: "厂商表字段导入",
          component: DataImport
        },
        {
          path: "dataImportEdit",
          name: "厂商表字段导入信息",
          component: DataImportEdit
        },
        {
          path: "deviceProtocolLookList",
          name: "查询指令",
          component: DeviceProtocolLookList
        },
        {
          path: "vendorEdit-copy",
          name: "设备厂商信息1",
          component: VendorEdit1
        },
        {
          path: "dataItemImport",
          name: "协议数据导入",
          component: DataItemImport
        },
        {
          path: "dataControlImport",
          name: "控制指令导入",
          component: DataControlImport
        },
        {
          path: "dataControlImportMQTT",
          name: "MQTT控制指令导入",
          component: DataControlImportMQTT
        },
        {
          path: "dataItemImportMQTT",
          name: "MQTT数据导入",
          component: DataItemImportMQTT
        },
        {
          path: "loraDtuManage",
          name: "loraDTU管理",
          component: LoraDtuManage
        },
        {
          path: "loraDtuManageEdit",
          name: "loraDTU管理信息",
          component: LoraDtuManageEdit
        },
        {
          path: "loraDtuManageImport",
          name: "loraDTU导入信息",
          component: LoraDtuManageImport
        },
        {
          path: "setNameplate",
          name: "设置铭牌",
          component: SetNameplate
        },
        {
          path: "setNameplateEdit",
          name: "设置铭牌信息",
          component: SetNameplateEdit
        },
        {
          path: "setPlcControl",
          name: "plc主从设置",
          component: SetPlcControl
        },
        {
          path: "setPlcControlEdit",
          name: "plc主从设置信息",
          component: SetPlcControlEdit
        },
        {
          path: "setDtu",
          name: "设置DTU",
          component: SetDtu
        },
        {
          path: "setDtuEdit",
          name: "DTU设置信息",
          component: SetDtuEdit
        },
        {
          path: "paramPattern",
          name: "参数配置",
          component: ParamPattern
        },
        {
          path: "paramPatternEdit",
          name: "参数配置信息",
          component: ParamPatternEdit
        },
        {
          path: "systemParams",
          name: "系统自定义参数",
          component: SystemParams
        },
        {
          path: "systemField",
          name: "系统参数配置",
          component: SystemField
        },
        {
          path: "middleFile",
          name: "中转",
          component: MiddleFile
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js